import { Fragment, useRef, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { ExclamationTriangleIcon, TrashIcon } from '@heroicons/react/24/outline'
import { PlusIcon, XMarkIcon, PencilSquareIcon } from '@heroicons/react/24/solid';

export default function Edit({ product, categories }) {
  const [open, setOpen] = useState(false)

  const [name, setName] = useState(product.name);
  const [price, setPrice] = useState(product.price);
  const [category, setCategory] = useState(product.category);
  const [description, setDescription] = useState(product.description);

  const cancelButtonRef = useRef(null)

  return (
    <>
    <button type="button" onClick={() => setOpen(true)} className="flex w-full items-center py-2 px-4 hover:bg-gray-100  text-gray-700 ">
        <PencilSquareIcon className="w-4 h-4 mr-2"/>
        Modifier
    </button>

    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-40" initialFocus={cancelButtonRef} onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all md:ml-64 sm:my-8 w-full sm:max-w-2xl">
                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                    <div className="mt-3 sm:mt-0 text-left">
                      <Dialog.Title as="div" className="flex justify-between ">
                        <p className='text-xl font-semibold leading-6 text-gray-900'>Modifier le produit</p>
                        <button
                            type="button"
                            className="inline-flex justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-100 sm:mt-0 w-auto"
                            onClick={() => setOpen(false)}
                            ref={cancelButtonRef}>
                            <XMarkIcon className='w-5 h-5 text-gray-900'/>
                        </button>
                      </Dialog.Title>
                      <div className="mt-4">
                        <form action="#" className='w-full'>
                            <div className="grid gap-4 mb-4 sm:grid-cols-2">
                                <div>
                                    <label className="block mb-2 text-sm font-medium text-gray-900">Nom du produit</label>
                                    <input 
                                        type="text"
                                        placeholder="Entrez le nom du produit" 
                                        value={name} onChange={(e) => setName(e.target.value)}
                                        required
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-black focus:border-black block w-full p-2.5 "
                                        />
                                </div>
                                <div>
                                    <label className="block mb-2 text-sm font-medium text-gray-900">Image</label>
                                    <input 
                                        type="file"
                                        required
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-black focus:border-black block w-full p-2.5 "
                                        />
                                </div>
                                <div>
                                    <label className="block mb-2 text-sm font-medium text-gray-900">Prix</label>
                                    <input 
                                        type="number" 
                                        placeholder="Entrez le prix" 
                                        value={price} onChange={(e) => setPrice(e.target.value)}
                                        required
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-black focus:border-black block w-full p-2.5 0" 
                                        />
                                </div>
                                <div>
                                    <label className="block mb-2 text-sm font-medium text-gray-900 ">Catégorie</label>
                                    <select 
                                        id="category" 
                                        value={category} onChange={e => setCategory(e.target.value)}
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-black focus:border-black block w-full p-2.5"
                                    >
                                        <option selected="">Choisir une catégorie</option>
                                        { categories.map((item)=>(
                                        <option value={item.slug}>{item.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="sm:col-span-2">
                                    <label className="block mb-2 text-sm font-medium text-gray-900">Description</label>
                                    <textarea 
                                        rows={4}
                                        placeholder="La description du produit ici"
                                        value={description} onChange={e => setDescription(e.target.value)}
                                        className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-black focus:border-black"
                                    />
                                </div>
                            </div>
                            <div className='flex justify-between'>
                              <button type="submit" className="text-white inline-flex items-center bg-black hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-500 font-medium rounded-lg text-sm px-5 py-2.5 text-center ">
                                  <PencilSquareIcon className="mr-1 -ml-1 w-6 h-6"/>
                                  Modifier
                              </button>
                              <form>
                                <button type="submit" className="text-red-600 inline-flex items-center bg-white border-2 border-red-600 hover:bg-red-600 hover:text-white focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center ">
                                  <TrashIcon className="mr-1 -ml-1 w-6 h-6"/>
                                  Supprimer
                                </button>
                              </form>
                            </div>
                        </form>
                    </div>
                    </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
    </>
  )
}
